import { Outlet, useNavigate } from "react-router-dom";
import {
  Container,
  Grid,
  IconButton,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { useEmpresaContext } from "../empresa-context";
import { MdArrowBack } from "react-icons/md";
import { Navigation } from "app/components";

const links = [
  // { to: "informacion-general", label: "Información General" },
  // { to: "reinscripciones", label: "Reinscripciones" },
  // { to: "afiliacion", label: "Afiliación" },
];

export function EmpresaLayout() {
  const navigate = useNavigate();
  const { data } = useEmpresaContext();

  return (
    <Stack className="animate__animated animate__fadeIn">
      <Paper
        sx={{
          padding: 1,
          borderBottom: "1px solid #e6e6e6",
        }}
        square
        elevation={0}
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <Tooltip title="Atrás">
            <IconButton onClick={() => navigate("../../", { replace: true })}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>

          <Typography variant="overline">
            <strong>
              {`${data.empresa_nombre_comercial} (${data.empresa_id})`}
            </strong>
          </Typography>
        </Stack>
      </Paper>

      <Grid container>
        {/* <Grid
          item
          xs={12}
          lg={2}
          sx={{
            borderRight: "1px solid #e6e6e6",
            borderBottom: "1px solid #e6e6e6",
            backgroundColor: "white",
          }}
        >
          <Navigation links={links} justified={false} />
        </Grid> */}

        <Grid item xs={12} lg={12} padding={0} minHeight="100vh">
          <Outlet />
        </Grid>
      </Grid>
    </Stack>
  );
}
